import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { CurrencyEnums } from "models/enums";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { EntityCardContent } from "components/common";
import { PausedPaymentsFooter, PausedPaymentsList, PausedPaymentsTodoSelection } from "components/payment";
import { usePausedPaymentsService } from "serviceHooks";
//#endregion
//#region services
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const PausedPaymentsTodo: React.FC<TodoCardProps> = (props) => {
  const pausedPaymentsService = usePausedPaymentsService();
  const pausedPayments = props.item.pausedPayments;
  const [selectedPaymentsCount, setTotalPaymentsCount] = React.useState<number>(0);
  const [selectedPaymentsTotalAmount, setTotalAmount] = React.useState<number>(0);
  const [selectedPayments, setSelectedPayments] = React.useState<ApiModels.PausedPayment[]>([]);
  const [loading, setLoading] = React.useState(false);

  const onSelectedPaymentsChange = (payments: ApiModels.PausedPayment[]) => {
    setSelectedPayments(payments);
  };

  React.useEffect(() => {
    setTotalPaymentsCount(selectedPayments.length);
    setTotalAmount(selectedPayments ? pausedPaymentsService.getTotalSelectedPaymentsAmount(selectedPayments) : 0);
  }, [selectedPayments]);

  const reloadTodo = (onSuccess?: (item: ApiModels.PausedPayments | null) => void) => {
    setSelectedPayments([]);
    setLoading(true);
    pausedPaymentsService
      .getPausedPayments()
      .then((result) => {
        onSuccess && onSuccess(result);
        props.onActionSuccess();
      })
      .finally(() => setLoading(false));
  };

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={`${LocalizationHelperInstance.getFormattedCurrency(pausedPayments!.amount ?? 0)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          descriptionHeadingTwo={`${pausedPayments?.total} ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Pc
          )}`}
          footerText={
            pausedPayments!.date !== undefined
              ? `${LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Common.Due_Date
                )}: ${LocalizationHelperInstance.getFormattedDate(pausedPayments!.date)}`
              : ""
          }
        />
      }
      todoMainSection={
        <PausedPaymentsTodoSelection
          selectedPaymentsCount={selectedPaymentsCount}
          selectedPaymentsTotal={selectedPaymentsTotalAmount}
        />
      }
      footer={
        <PausedPaymentsFooter
          selectedPayments={selectedPayments}
          isValid={selectedPaymentsCount > 0}
          reloadHandler={reloadTodo}
          disableSuccessMessages
        />
      }
      infoViewer={
        <PausedPaymentsList
          items={pausedPayments!.pausedPaymentList}
          onRowSelectionsChange={onSelectedPaymentsChange}
          selectedPayments={selectedPayments}
        />
      }
      loading={loading}
    ></EntityCardContent>
  );
};

export default PausedPaymentsTodo;
